class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.submitButton = this.querySelector('[data-sticky-atc-submit]');
    this.target = document.getElementById(this.dataset.watchTarget);
    if (!this.target || !this.submitButton) return;

    this.submitButton.addEventListener('click', () => {
      this.target.click();
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('sticky-atc--visible');
          } else if (entry.boundingClientRect.top < 0) {
            this.classList.add('sticky-atc--visible');
          } else {
            this.classList.remove('sticky-atc--visible');
          }
        });
      },
      { threshold: 0 }
    );
    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
